import React from 'react';
import { Link } from 'react-router-dom';
import logoIcon from 'url:../assets/logo-icon.svg';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-50 border-t border-gray-200 relative">
      {/* Dot grid overlay */}
      <div className="absolute inset-0 dot-grid opacity-30 pointer-events-none" />

      <div className="container mx-auto px-4 max-w-7xl py-12 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img src={logoIcon} alt="AOK Financial" className="h-8 w-auto" />
            </div>
            <p className="text-sm text-gray-500">
              US Equity Trading Infrastructure for Global Brokerages
            </p>
            <div className="mt-4">
              <a
                href="mailto:info@aokfin.com"
                className="text-sm text-brand-600 hover:text-brand-500 font-mono transition-colors"
              >
                info@aokfin.com
              </a>
            </div>
          </div>

          {/* Platform */}
          <div>
            <h3 className="text-brand-600 font-mono text-xs uppercase tracking-widest mb-4">Platform</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/platform" className="text-gray-500 hover:text-gray-900 transition-colors duration-200">
                  Features
                </Link>
              </li>
              <li>
                <Link to="/docs" className="text-gray-500 hover:text-gray-900 transition-colors duration-200">
                  API Documentation
                </Link>
              </li>
              <li>
                <Link to="/dashboard" className="text-gray-500 hover:text-gray-900 transition-colors duration-200">
                  Dashboard
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-brand-600 font-mono text-xs uppercase tracking-widest mb-4">Company</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/about" className="text-gray-500 hover:text-gray-900 transition-colors duration-200">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-500 hover:text-gray-900 transition-colors duration-200">
                  Contact
                </Link>
              </li>
              <li>
                <a
                  href="mailto:partnerships@aokfin.com"
                  className="text-gray-500 hover:text-gray-900 transition-colors duration-200"
                >
                  Partnerships
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-brand-600 font-mono text-xs uppercase tracking-widest mb-4">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/disclosures" className="text-gray-500 hover:text-gray-900 transition-colors duration-200">
                  Disclosures
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-500 hover:text-gray-900 transition-colors duration-200">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-500 hover:text-gray-900 transition-colors duration-200">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-200 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-gray-500 font-mono">
          <p>
            &copy; {currentYear} AOK Financial Inc. All rights reserved.
          </p>
          <p className="mt-2 md:mt-0">
            SEC Registration In Progress | FINRA Membership Pending
          </p>
        </div>
      </div>
    </footer>
  );
}
